import { css, StyleSheet } from 'aphrodite';
import _ from 'lodash';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, Sidebar as SemanticSidebar } from 'semantic-ui-react';

import {
    GROUPS_VIEW_REQUIRED_PERMISSION,
    PERMISSIONS_VIEW_REQUIRED_PERMISSION,
    USERS_VIEW_REQUIRED_PERMISSION,
} from '../../application/security/permissions';

import SidebarItem from './SidebarItem';

const styles = StyleSheet.create({
    sidebar: {
        backgroundImage: 'linear-gradient(to right, #3C9700 , #66B100)',
        ':active': {
            backgroundColor: '#286400',
        },
    },
});

interface State {
    activeItem: string;
}

function resolveActiveButtonBasedOnPath(pathname: string) {
    const categories = ['users', 'groups', 'permissions'];
    const result = _.find(categories, (category) => pathname.includes(category));
    return result === undefined ? '' : result;
}

export function Sidebar() {
    const location = useLocation();
    const navigation = useNavigate();
    const [state, setState] = useState<State>({
        activeItem: resolveActiveButtonBasedOnPath(location.pathname),
    });

    return (
        <SemanticSidebar
            as={Menu}
            className={css(styles.sidebar)}
            icon="labeled"
            inverted
            vertical
            visible
            width="thin">
            <SidebarItem
                active={state.activeItem === 'users'}
                menuIcon="user"
                menuText={'Users'}
                onClick={() => {
                    setState({ activeItem: 'users' });
                    navigation('/users');
                }}
                requiredPermission={USERS_VIEW_REQUIRED_PERMISSION}
            />
            <SidebarItem
                active={state.activeItem === 'groups'}
                menuIcon="group"
                menuText={'Groups'}
                onClick={() => {
                    setState({ activeItem: 'groups' });
                    navigation('/groups');
                }}
                requiredPermission={GROUPS_VIEW_REQUIRED_PERMISSION}
            />
            <SidebarItem
                active={state.activeItem === 'permissions'}
                menuIcon="key"
                menuText={'Permissions'}
                onClick={() => {
                    setState({ activeItem: 'permissions' });
                    navigation('/permissions');
                }}
                requiredPermission={PERMISSIONS_VIEW_REQUIRED_PERMISSION}
            />
        </SemanticSidebar>
    );
}

export default Sidebar;
